
import { createContext } from "react";

export const PermissionsContext = createContext<PermissionsContextType>({
    permissions: [],
    setPermissions: (val) => []
});

export type PermissionsContextType = {
    permissions: string[];
    setPermissions: (val: string[]) => void;
};